<template>
  <div>
    <z-header title="Últimos Registros" :actions="actions">
    <div>
      <p class="has-text-right">
        <button @click="goToExtrato" class="is-primary button">Extrato completo</button>
      </p>
    </div>
    </z-header>    
    <section>
      <b-table
        :data="data"
        :hoverable="true"
        :striped="true"
        :row-class="rowClass"
        :mobile-cards="true"
        :loading="isLoading"
        default-sort="date"
        default-sort-direction="desc"
        sort-icon="sort-up"
        :paginated="false"
        :pagination-simple="true"
        aria-next-label="Proxima página"
        aria-previous-label="Página anterior"
        aria-page-label="Página"
        aria-current-label="Página atual"
      >
        <template slot-scope="props">
          <b-table-column field="date" label="Data" sortable>{{
            props.row.date | dateTime
          }}</b-table-column>

          <b-table-column field="username" label="Usuário" sortable>{{
            props.row.userName
          }}</b-table-column>

          <b-table-column field="registrationPlate" label="Veículo" sortable>
            {{ props.row.registrationPlate }}
          </b-table-column>

          <b-table-column field="description" label="Descrição" sortable>{{
            props.row.description
          }}</b-table-column>

          <b-table-column field="amount" label="Valor" sortable>{{
            ((props.row.type == "DEBIT" ? -1 : 1) * props.row.amount) | money
          }}</b-table-column>
        </template>
        <template slot="empty">
          <section v-if="!isLoading" class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="sad-tear" size="is-large"></b-icon>
              </p>
              <p>Sem dados da frota.</p>
            </div>
          </section>
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
import ZHeader from "../../layout/Header";
import reports from "../../services/reports";

import "../../filters/dateTime";
import "../../filters/money";
import "../../filters/registration-plate";

export default {
  props: ["newTitle", "enableFilters", "enablePagination"],
  data() {
    return {
      title: this.newTitle || "Extrato",
      actions: [],
      data: [],
      users: [],
      departments: [],
      isLoading: false,
      firstLoad: true,
      filters: {}
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      
      const filters = {
        limit: 15
      };

      reports
        .getRecentStatements(
          filters
        )
        .then(data => {
          this.isLoading = false;
          this.data = data;
        });
    },
    rowClass() {
      return "is-clickable";
    },
    goToExtrato(e) {
      e.preventDefault();

      this.$router.push("/extrato")
    }
  },
  components: {
    ZHeader
  }
};
</script>

<style lang="scss"></style>
